import { trackEvent } from "@utils/tracking";
import type {
  HandoffBeatId,
  HandoffBranch,
  HandoffVariant,
} from "./handoffTypes";

export function trackHandoffStart(attrs: {
  has_goal: boolean;
  reduced_motion: boolean;
  variant: HandoffVariant;
  branch: HandoffBranch;
}): void {
  trackEvent("handoff_start", attrs);
}

export function trackHandoffBeatView(attrs: {
  beat_id: HandoffBeatId;
  beat_index: number;
}): void {
  trackEvent("handoff_beat_view", attrs);
}

export function trackHandoffBeatAdvance(attrs: {
  beat_id: HandoffBeatId;
}): void {
  trackEvent("handoff_beat_advance", attrs);
}

export function trackHandoffComplete(): void {
  trackEvent("handoff_complete", { ended_on: "brief" });
}

export function trackHandoffSkip(attrs: {
  beat_id: HandoffBeatId;
  at_beat: number;
}): void {
  trackEvent("handoff_skip", attrs);
}

export function trackHandoffActivateTap(): void {
  trackEvent("handoff_activate_tap", { source: "handoff" });
}
